import { render, staticRenderFns } from "./DeleteReviewConfirmationModal.vue?vue&type=template&id=19605595&scoped=true"
import script from "./DeleteReviewConfirmationModal.vue?vue&type=script&lang=js"
export * from "./DeleteReviewConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19605595",
  null
  
)

export default component.exports